var font = {
    "-": "M370.8,757.9c0,0,621.1,0,621.1,0v-288H370.8C370.8,469.9,370.8,757.8,370.8,757.9z",
    "'": "M706.9,1637c0,0,0-465,0-465h-237l-99,465C370.8,1637,706.8,1637,706.9,1637z",
    ".": "M0 0h1024v1024h-1024v-1024z",
 	"0": "M565.952 97.697l-97.697-97.697h-370.557l-97.697 97.697v828.605l97.697 97.697h370.557l97.697-97.697zM364.543 821.861h-162.404v-619.722h162.404z",
	"1": "M337.082 202.249v-202.249h-337.082v202.249h67.416v619.502h-67.416v202.249h269.665v-821.751z",
    "2": "M468.255 404.278h-266.116v-202.139h363.813v-202.139h-565.952v508.719l97.697 97.515h266.116v215.627h-161.675v-94.234h-202.139v198.676l97.697 97.697h370.557l97.697-97.697v-424.328l-97.697-97.697z",
    "3": "M522.025 512l43.927-43.745v-370.557l-97.697-97.697h-370.557l-97.697 97.697v198.676h202.139v-94.234h161.675v202.139h-175.163v201.957h175.163v215.627h-161.675v-94.234h-202.139v198.676l97.697 97.697h370.557l97.697-97.697v-370.557l-43.927-43.745z",
    "4": "M679.63 202.249h-67.416v-202.249h-202.249v202.249h-338.904l-71.060 140.299 338.904 679.63h273.31v-619.502h67.416v-200.427zM409.964 404.498v329.794l-165.808-329.794h165.808z",
    "5": "M564.84 521.11v-422.719l-96.569-98.391h-369.879l-98.391 98.391v198.605h202.249v-94.747h162.164v215.004h-266.021l-98.391 98.391v508.356h564.84v-202.249h-362.591v-202.249h266.021z",
    "6": "M468.27 619.502l98.391-98.391v-422.719l-98.391-98.391h-369.879l-98.391 98.391v829.039l98.391 98.391h369.879l98.391-98.391v-200.427h-202.249v94.747h-162.164v-202.249h266.021zM364.413 417.253h-162.164v-215.004h162.164v215.004z",
    "7": "M428.185 202.249h56.484v-202.249h-349.836v202.249h76.527l154.875 619.502h-163.986v-94.747h-202.249v296.996h528.399l69.238-140.299z",
    "8": "M522.025 512l43.927-43.745v-370.557l-97.697-97.697h-370.557l-97.697 97.697v370.557l43.745 43.745-43.745 43.745v370.557l97.697 97.697h370.557l97.697-97.697v-370.557zM202.139 202.139h162.404v202.139h-162.404zM363.813 821.861h-161.675v-215.627h162.404z",
    "9": "M98.391 417.253l-98.391 98.391v409.964l98.391 98.391h369.879l98.391-98.391v-827.217l-98.391-98.391h-369.879l-98.391 98.391v198.605h202.249v-94.747h162.164v215.004h-266.021zM202.249 619.502h162.164v202.249h-162.164v-202.249z",
    "A": "M431.721 945.505v-945.505h-149.854v378.202h-132.014v-378.202h-149.854v945.505l82.063 82.063h267.596l82.063-82.063zM281.868 524.488v349.659h-132.014v-349.659h132.014z",
	"B": "M431.721 474.537v-392.474l-82.063-82.063h-349.659v1024h349.659l82.063-82.063v-363.93l-53.519-53.519 53.519-49.951zM149.854 599.415h135.582v274.732h-135.582v-274.732zM281.868 146.286v303.275h-132.014v-303.275h132.014z",
    "C": "M431.721 281.868v-199.805l-82.063-82.063h-267.596l-82.063 82.063v859.875l82.063 82.063h267.596l82.063-82.063v-185.533h-149.854v121.31h-132.014v-727.861h132.014v132.014z",
    "D": "M349.659 1024l82.063-82.063v-859.875l-82.063-82.063h-349.659v1024h349.659zM281.868 877.714h-132.014v-727.861h135.582v727.861z",
    "E": "M149.854 877.714v-278.3h185.533v-146.286h-185.533v-303.275h228.348v-149.854h-378.202v1024h378.202v-146.286z",
    "F": "M149.854 877.714v-278.3h185.533v-146.286h-185.533v-453.129h-149.854v1024h378.202v-146.286z",
    "G": "M431.721 599.415v-599.415h-349.659l-82.063 82.063v859.875l82.063 82.063h267.596l82.063-82.063v-185.533h-149.854v121.31h-132.014v-727.861h132.014v303.275h-64.223v146.286z",
    "H": "M431.721 1024v-1024h-149.854v453.129h-132.014v-453.129h-149.854v1024h149.854v-424.585h132.014v424.585z",
    "I": "M0 0h148.323v1024h-148.323v-1024z",
    "J": "M281.868 1024h149.854v-941.937l-82.063-82.063h-267.596l-82.063 82.063v203.373h149.854v-135.582h135.582v874.146z",
    "K": "M485.24 0h-160.557l-121.31 456.697-53.519-146.286v-310.411h-149.854v1024h149.854v-417.449l160.557 417.449h160.557l-167.693-396.042z",
    "L": "M378.202 149.854v-149.854h-378.202v1024h149.854v-874.146z",
    "M": "M592.279 1024v-1024h-146.286v578.007l-149.854-442.425-146.286 442.425v-578.007h-149.854v1024h128.446l167.693-524.488 167.693 524.488z",
    "N": "M460.265 1024v-1024h-142.718l-167.693 606.551v-606.551h-149.854v1024h142.718l167.693-606.551v606.551z",
    "O": "M80.936 0l-80.936 80.936v862.128l80.936 80.936h269.192l80.936-80.936v-862.128l-80.936-80.936zM283.097 875.677h-134.774v-727.354h134.774z",
    "P": "M431.721 460.265l-82.063-82.063h-199.805v-378.202h-149.854v1024h349.659l82.063-82.063v-481.672zM281.868 877.714h-132.014v-349.659h135.582v349.659z",
    "Q": "M410.278 128.848l-77.987-77.987 13.563-50.861h-139.020l-13.563 50.861h-115.285l-77.987 77.987v820.556l77.987 77.987h254.305l77.987-77.987v-820.556zM142.411 193.272h128.848v691.709h-128.848v-691.709z",
    "R": "M296.139 0l-96.334 378.202h-49.951v-378.202h-149.854v1024h349.659l82.063-82.063v-485.24l-82.063-82.063 103.47-374.634h-156.99zM149.854 524.488h135.582v349.659h-135.582v-349.659z",
    "S": "M431.721 82.063l-82.063-82.063h-267.596l-82.063 82.063v199.805h149.854v-132.014h132.014v303.275h-199.805l-82.063 85.631v403.178l82.063 82.063h267.596l82.063-82.063v-185.533h-149.854v121.31h-132.014v-278.3h199.805l82.063-85.631z",
    "T": "M460.265 877.714h-156.99v-877.714h-149.854v877.714h-153.422v146.286h460.265z",
    "U": "M431.721 1024v-941.937l-82.063-82.063h-267.596l-82.063 82.063v941.937h149.854v-874.146h132.014v874.146z",
    "V": "M335.387 1024l-92.767-849.171-92.767 849.171h-149.854l135.582-1024h214.077l135.582 1024z",
    "W": "M727.861 1024l-117.742-1024h-167.693l-78.495 620.822-78.495-620.822h-167.693l-117.742 1024h149.854l53.519-742.132 89.199 742.132h142.718l89.199-742.132 53.519 742.132z",
    "X": "M349.659 0l-92.767 335.387-96.334-335.387h-160.557l174.829 538.76-160.557 485.24h160.557l82.063-296.139 78.495 296.139h164.125l-164.125-485.24 178.397-538.76z",
    "Y": "M331.819 363.93v-363.93h-149.854v363.93l-181.965 660.070h160.557l96.334-456.697 92.767 456.697h164.125z",
    "Z": "M160.557 149.854h242.62v-149.854h-403.178v135.582l242.62 742.132h-242.62v146.286h403.178v-135.582z",
    };
    // Colors are in order like this...  home: [ inside, outline, outline2, outline3 ]
    var 
      font_size = 26,
      panel_Hor_Adjustment = 2,
      font_Top_Adjustment = -18,
      tracking = 4,
      small_Caps_Adjustment = {
        vertical: 0,
        horizontal: 0,
        scale_width: 0,
        scale_height: 0,
      },
      colors = {
        characters: {
          home: [
            "#323E48", // grey
          ],         
          away: [
            "#262F38", // grey 
            "#B38247", // gold
          ],
          third: [
            "#ffffff", // white
            "#B38247", // gold
          ]
        },
        numbers: {
          home: [
            "#323E48", // Grey
            "#FFFFFF", // White                      
          ],
          away: [
            "#262F38", // grey
            "#B38247", // gold
          ],
          third: [
            "#FFFFFF", // white
            "#B38247", // gold
          ]
        }
      },
      outlines = {
        characters: {
          width: 1.7
        },
        numbers: {
          width: 2.5
        }
      },
      special_Character_Adjustments = {
        period: {
          vertical: -1.5, // this moves it up from the bottom
          horizontal: -2,
          scale_width: -8,
          scale_height: -8,
        },
        hyphen: {
          vertical: -8,
          horizontal: -5.5,
          scale_width: 0,
          scale_height: -3,
        },
        apostrophe: {
          vertical: -0.75, // this is backwards
          horizontal: -1,
          scale_width: 0,
          scale_height: 0,
        }
      },
       number_Adjustments = {
        top: 20,
        left: -6,
        width:102,
        height: 97.55,
        middle_Space: 5,
        oneOffset: 7
      };